export default __webpack_public_path__ + "static/media/bg6.b76e4d2b.jpg";